import styled, { css, DefaultTheme } from 'styled-components';

import { hexToRGBA } from 'src/utils/hex-to-rgba';

import { ModalProps, ModalSize } from './Modal.types';

export const getModalStyles = (size: ModalSize, width?: string, height?: string) => {
  switch (size) {
    case 'small':
      return css`
        max-width: ${width ? 'unset' : '300px'};
        width: ${width ?? ' 300px'};
        max-height: 95%;
      `;
    case 'large':
      return css`
        max-width: 800px;
        width: ${width ?? ' 800px'};
        max-height: 95%;
      `;
    case 'full-screen':
      return css`
        width: 95%;
        height: 95%;

        ${({ theme }) => theme.mediaQueries.md} {
          width: 100% !important;
          height: ${height ?? '100%'} !important;
          box-shadow: unset !important;
          border-radius: 0 !important;
          transform: unset !important;
          position: absolute !important;
          bottom: 0 !important;
          top: unset !important;
        }
      `;
    case 'medium':
      return css`
        max-width: 500px;
        width: ${width ?? ' 500px'};
        max-height: 95%;
      `;
    case 'auto':
      return css`
        max-width: ${width ? 'unset' : '95%'};
        width: ${width ?? ' min-content'};
        max-height: 95%;
      `;
  }
};

export const Backdrop = styled.div<ModalProps>`
  background-color: ${(props) =>
    props.backdropBgColor ?? hexToRGBA(props.theme.colors.background.inverse, 0.2)};
  backdrop-filter: ${(props) => (props.backdropBlur ? 'blur(8px)' : 'blur(1px)')};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12000;

  ${({ theme }) => theme.mediaQueries.md} {
    align-items: flex-start;
  }
`;

export const StyledModal = styled.div<
  ModalProps & {
    modalStyles: any;
    defaulttheme: DefaultTheme;
  }
>`
  z-index: 12001;
  position: relative;
  background-color: ${({ backgroundColor, defaulttheme }) =>
    backgroundColor ?? defaulttheme.colors.background.secondary.BG2};
  border-radius: 10px;
  box-shadow: 0 20px 24px -4px ${(props) => hexToRGBA(props.theme.colors.background.inverse, 0.1)},
    0px 8px 8px -4px ${(props) => hexToRGBA(props.theme.colors.background.inverse, 0.01)};
  min-height: 100px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  outline: none;
  -webkit-overflow-scrolling: touch;
  ${(props) => props.modalStyles};

  ${({ theme }) => theme.mediaQueries.md} {
    width: 95%;
    border-radius: 8px;
    padding: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const CloseButton = styled.button`
  border: 0;
  padding: 0;
  outline: 0;
  top: 24px;
  right: 24px;
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  display: flex;
  z-index: 12001;

  ${({ theme }) => theme.mediaQueries.md} {
    top: 16px;
    right: 16px;
  }
`;
